import { render, staticRenderFns } from "./MemberFavorites.vue?vue&type=template&id=b5238cf2"
import script from "./MemberFavorites.vue?vue&type=script&lang=js"
export * from "./MemberFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports